var map = {
	"./solutions/AboutUs.png": 588,
	"./solutions/Diabetes.png": 24,
	"./solutions/Healthcare.png": 130,
	"./solutions/PCOS.png": 742,
	"./solutions/Thyroid.png": 848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;